import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/OptiE-Invoice-b2c.png"
      {...props}
    />
  );
};

export default Logo;
